import { __awaiter } from "tslib";
import { utils } from "@project-serum/anchor";
import { PublicKey } from "@solana/web3.js";
import { CLAIM_REQUEST_SEED, ENTRY_SEED, GLOBAL_CONTEXT_SEED, NAMESPACE_SEED, NAMESPACES_PROGRAM_ID, REVERSE_ENTRY_SEED, } from "./constants";
/**
 * Finds the namespace id.
 * @returns
 */
export const findNamespaceId = (namespaceName) => __awaiter(void 0, void 0, void 0, function* () {
    return PublicKey.findProgramAddress([
        utils.bytes.utf8.encode(NAMESPACE_SEED),
        utils.bytes.utf8.encode(namespaceName),
    ], NAMESPACES_PROGRAM_ID);
});
/**
 * Finds the entry id in a given namespace.
 * @returns
 */
export const findNameEntryId = (namespaceId, entryName) => __awaiter(void 0, void 0, void 0, function* () {
    return PublicKey.findProgramAddress([
        utils.bytes.utf8.encode(ENTRY_SEED),
        namespaceId.toBytes(),
        utils.bytes.utf8.encode(entryName),
    ], NAMESPACES_PROGRAM_ID);
});
/**
 * Finds the claim request ID for a given namespace and name.
 * @returns
 */
export const findClaimRequestId = (namespaceId, entryName, requestor) => __awaiter(void 0, void 0, void 0, function* () {
    return PublicKey.findProgramAddress([
        utils.bytes.utf8.encode(CLAIM_REQUEST_SEED),
        namespaceId.toBytes(),
        utils.bytes.utf8.encode(entryName),
        requestor.toBytes(),
    ], NAMESPACES_PROGRAM_ID);
});
/**
 * Finds the reverse entry ID for a given publickey.
 * @returns
 */
export const findReverseEntryId = (pubkey) => __awaiter(void 0, void 0, void 0, function* () {
    return PublicKey.findProgramAddress([utils.bytes.utf8.encode(REVERSE_ENTRY_SEED), pubkey.toBytes()], NAMESPACES_PROGRAM_ID);
});
/**
 * Finds the namespace id.
 * @returns
 */
export const findGlobalContextId = () => __awaiter(void 0, void 0, void 0, function* () {
    return PublicKey.findProgramAddress([utils.bytes.utf8.encode(GLOBAL_CONTEXT_SEED)], NAMESPACES_PROGRAM_ID);
});
//# sourceMappingURL=pda.js.map